import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import VendorTermsAndConditionContent from "./components/vendorTermsAndConditionContent";

const VendorTermsAndCondition = () => {
  return (
    <div>
      <TitleHolder>Vendor Terms&Condition</TitleHolder>
      <StepperContentHolder>
        <VendorTermsAndConditionContent />
      </StepperContentHolder>
    </div>
  );
};

export default VendorTermsAndCondition;
